import { Action, createReducer, on } from '@ngrx/store';
import { RouteActions } from './route.actions';
import { RouteState } from './route.state';

const initialRouteState: RouteState = {
    routeAndPath: {USER: undefined}
};

// NgRX 8 syntax
const reducer = createReducer(
  initialRouteState,
  on(RouteActions.setRouteAndPath, (state, payload) => ({
    ...state,
    routeAndPath: {...state.routeAndPath,
                   [payload.route]: payload.pathAndParam
      }
  }))
);

// tslint:disable-next-line:only-arrow-functions
export function routeReducer(state: RouteState | undefined, action: Action): RouteState {
  return reducer(state, action);
}
